import React from 'react';
import SimpleCard from '../teal-react/components/organisms/SimpleCard';
import { EditOutlined } from '@mui/icons-material';
import { useQuery, useSave } from '../graphql/hooks';
import SimpleModal from '../teal-react/components/organisms/SimpleModal';
import SimpleForm from '../teal-react/components/organisms/SimpleForm';
import { useAuth } from '../teal-react/utils/token';
// import { Api, Utils } from '@jesseteal/teal-react'

const BatchNotesManager = ({ qc_id }: { qc_id: number }) => {
  const { user } = useAuth();
  const [show, setShow] = React.useState(false);
  const saveNotes = useSave('batch', 'batch');
  const { data } = useQuery(
    `query BatchNotesManager($where: String){
      batch(where: $where){
        id
        notes
      }
    }`,
    {
      variables: { where: JSON.stringify({ qc_id }) },
    }
  );
  if (!data) {
    return null;
  }
  const batch = data.batch[0];
  return (
    <>
      <SimpleCard
        subheader="Notes"
        headeraction={
          user?.isRO
            ? null
            : {
                icon: <EditOutlined color="primary" />,
                onClick: () => {
                  setShow(true);
                },
              }
        }
      >
        {batch?.notes ? (
          <div style={{ whiteSpace: 'break-spaces' }}>{batch.notes}</div>
        ) : (
          <div style={{ color: '#CCC' }}>No notes entered.</div>
        )}
      </SimpleCard>
      <SimpleModal open={show} onClose={() => setShow(false)}>
        <SimpleForm
          header="Notes"
          model={batch || {}}
          cancel={() => setShow(false)}
          save={({ modified }: { modified: any }) => {
            if (batch?.id) {
              saveNotes({
                id: batch.id,
                ...modified,
              }).then(() => setShow(false));
            } else {
              saveNotes(
                {
                  qc_id,
                  ...modified,
                },
                true
              ).then(() => setShow(false));
            }
          }}
          fields={[
            {
              name: 'notes',
              label: 'Notes',
              multiline: 6,
            },
          ]}
        />
      </SimpleModal>
    </>
  );
};

export default BatchNotesManager;
